import { RouteObject } from 'react-router-dom';
import { unauthentifiedRoutes } from './bundles/unauthentified/unauthentified';
import { authentifiedLightRoutes } from './bundles/authentified/light/light';
import { authentifiedRoutes } from './bundles/authentified/authentified';

export const routes: (isLogged: boolean, signature: string | null | undefined) => RouteObject[] = (
    isLogged: boolean,
    signature: string | null | undefined
) => [...unauthentifiedRoutes(isLogged), ...authentifiedLightRoutes(isLogged, signature), ...authentifiedRoutes(isLogged)];
